export default "__VITE_ASSET__de0a8b3f__"